import React, { FC, RefObject } from 'react';

import { GlobalStyle } from '@r1-frontend/ui-react/components/GlobalStyles';

import CitySelectContainer from '~/src/components/CitySelectContainer';
import { Footer } from '~/src/components/Footer';
import { CDN_API_ENDPOINT } from '~/src/constants';
import Chat from '~/src/features/_layout/Chat';
import Header from '~/src/features/_layout/Header';

import * as ST from './styled';

interface IApp {
    withMenu: boolean,
    withChat: boolean,
    withFooter: boolean,
    withBottomSticky?: RefObject<HTMLDivElement>,
    bgColor?: string,
    withEmailWidget?: boolean,
    emailWidgetText?: string,
}

const App: FC<IApp> = ({
    withMenu,
    withChat,
    withFooter,
    bgColor,
    withEmailWidget,
    withBottomSticky,
    emailWidgetText,
    children,
}) => {
    return (
        <ST.AppContainer bgColor={bgColor} ref={withBottomSticky}>
            <GlobalStyle endpoint={CDN_API_ENDPOINT}/>
            <ST.GlobalStyle/>
            {withMenu && <Header data-test='main-menu'/>}
            <ST.Content>
                {children}

                {withFooter && <Footer
                    withEmailWidget={withEmailWidget}
                    emailWidgetText={emailWidgetText}
                    withChat={withChat}
                />}
            </ST.Content>

            <Chat enabled={withChat}/>

            <CitySelectContainer/>
        </ST.AppContainer>
    );
};

export default App;
